"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var PrePaymentResource = /** @class */ (function (_super) {
    tslib_1.__extends(PrePaymentResource, _super);
    function PrePaymentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrePaymentResource.endpoint = '/pps';
    PrePaymentResource.MODEL_NAME = 'prepayment';
    return PrePaymentResource;
}(index_1.BaseTransactionResource));
exports.default = PrePaymentResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pp/index.js
// module id = Crj5
// module chunks = 0